import { useMsal } from "@azure/msal-react";
import { useCallback, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import appRoles from "../../Helpers/Auth/Roles";

const Dashboard = () => {
	const { instance } = useMsal();
	const [isAdmin, setIsAdmin] = useState(false);
	const [isCst, setIsCst] = useState(false);
	const navigate = useNavigate();

	const onLoad = useCallback(async () => {
		const currentAccount = instance.getAllAccounts()[0];

		if (currentAccount?.idTokenClaims?.roles) {
			const adminRole = currentAccount.idTokenClaims.roles.indexOf(appRoles.admin) > -1;
			setIsAdmin(adminRole);

			const cstRole = currentAccount.idTokenClaims.roles.indexOf(appRoles.cst) > -1;
			setIsCst(cstRole);

			const networkPartnerRole = currentAccount.idTokenClaims.roles.indexOf(appRoles.networkPartner) > -1;
			if (networkPartnerRole) navigate("/engagement-history");
		}
	}, [instance, navigate]);

	useEffect(() => {
		onLoad();
	}, [onLoad]);

	return (
		<div>
			{isAdmin || isCst ? (
				<div>
					<h4>Dashboard</h4>
					<ul>
						{isAdmin && (
							<>
								<li>
									<Link to="/rules" className="dashboard-nav-link">
										Rules
									</Link>
								</li>
								<li>
									<Link to="/rulesets" className="dashboard-nav-link">
										Rulesets
									</Link>
								</li>
								<li>
									<Link to="/pathways" className="dashboard-nav-link">
										Pathways
									</Link>
								</li>
								<li>
									<Link to="/surveys" className="dashboard-nav-link">
										Surveys
									</Link>
								</li>
								<li>
									<Link to="/adhoc-surveys" className="dashboard-nav-link">
										Ad-hoc surveys
									</Link>
								</li>
							</>
						)}
						<li>
							<Link to="/admin" className="dashboard-nav-link">
								Admin tools
							</Link>
						</li>
						<li>
							<Link to="/engagement-history" className="dashboard-nav-link">
								Engagement History
							</Link>
						</li>
					</ul>
				</div>
			) : (
				""
			)}
		</div>
	);
};

export default Dashboard;
